<div class="d-lg-none" style="overflow-x: hidden">
  @if (disableQAM() && showLeftPanel) {
  <div (click)="menuClick()" class="quick-access-header row">
    <div class="col-10 quick-access-menu-title" tabindex="0">
      <strong>{{ "QUICK_ACCESS_MENU" | globalTranslate }}</strong>
    </div>
    <div class="col-2 p-0 quick-access-menu-icon">
      @if (showTutorialInMobileView ? !isMenuOpened &&
      !joyrideService.isTourInProgress() : !isMenuOpened) {
      <img
        src="../../../assets/images/⚛️ Qam_Collapsed.svg"
        alt="collapsed-icon"
      />
      } @if (showTutorialInMobileView ? isMenuOpened ||
      joyrideService.isTourInProgress() : isMenuOpened) {
      <img
        src="../../../assets/images/⚛️ Qam_Expanded.svg"
        alt="Expanded-icon"
      />
      }
    </div>
  </div>
  } @if (showTutorialInMobileView ? isMenuOpened ||
  joyrideService.isTourInProgress() : isMenuOpened) {
  <div class="card shadow-sm">
    <div class="card-user link-style">
      <section
        id="step6"
        #step6
        joyrideStep="Step6"
        stepPosition="bottom"
        text="{{ 'TUTORIAL_1_MOBILE' | globalTranslate }}"
        class="side-section-header"
      >
        <div class="row">
          <div class="col-2 profile-pic" aria-hidden="true">
            <img
              src="../../../assets/images/profile_pic.svg"
              alt="profile pic"
            />
          </div>
          <div class="col-10 profile-details">
            <div class="profile-name">
              <span>
                {{ userDetails?.firstName }}
                {{ userDetails?.middleName }}
                {{ userDetails?.lastName }}
              </span>
            </div>
            <div class="profile-email">
              {{
                userDetails?.emailId ? userDetails?.emailId : userDetails?.email
              }}
            </div>
          </div>
        </div>
      </section>
      <section
        id="step7"
        #step7
        joyrideStep="Step7"
        stepPosition="right"
        text="{{ 'TUTORIAL_2' | globalTranslate }}"
        class="side-section"
      >
        <div class="sub-title" [routerLink]="['benefit-dashboard']">
          <span>{{ "MY_COVERAGE" | globalTranslate }}</span>
        </div>
        <ul>
          <li
            [routerLink]="['benefit-dashboard']"
            [routerLinkActive]="['selected']"
          >
            <a class="add-primary-color">{{
              "COVERAGE_DASHBOARD" | globalTranslate
            }}</a>
          </li>
          @if (!hoveredOnHealthPlan && !this.isFromPartnerPortal &&
          mcoMasterSwitch && showHealthPlanDetails) {
          <li
            [routerLink]="['healthplan-details']"
            [routerLinkActive]="['selected']"
            (mouseover)="hoveredOnHealthPlan = !showHealthPlanDetails"
          >
            <a class="add-primary-color">
              {{ "HEALTH_PLAN_DETAILS" | globalTranslate }}</a
            >
          </li>
          }
          <!-- <li *ngIf="hoveredOnHealthPlan && !this.isFromPartnerPortal && mcoMasterSwitch" class="renew-coverage" (mouseout)="hoveredOnHealthPlan = showHealthPlanDetails ">{{'REPORT_CHANGE_HOVER' | globalTranslate }}</li> -->
          @if (!this.isFromPartnerPortal && !hoveredOnAFB) {
          <li
            (mouseover)="hoveredOnAFB = isLinkDisable"
            (click)="isLinkDisable ? $event.preventDefault() : applyNow()"
          >
            <a
              tabindex="0"
              [class.disabled]="isLinkDisable"
              class="add-primary-color"
              [attr.aria-label]="
                ('WELCOME_APPLY_COVERAGE_HEADER' | globalTranslate) +
                (isLinkDisable ? ' ' + 'unavailable' : '')
              "
              >{{ "WELCOME_APPLY_COVERAGE_HEADER" | globalTranslate }}</a
            >
          </li>
          } @if (!this.isFromPartnerPortal && hoveredOnAFB &&
          this.translatedLang === 'en') {
          <li (mouseout)="hoveredOnAFB = false" class="renew-coverage">
            <span><b [innerHtml]="'AFB_HOVER_01' | globalTranslate"></b></span
            >&nbsp;
            <span [innerHtml]="'AFB_HOVER_02' | globalTranslate"></span>&nbsp;
            <span><b [innerHtml]="'AFB_HOVER_03' | globalTranslate"></b></span
            >&nbsp;
            <span [innerHtml]="'AFB_HOVER_04' | globalTranslate"></span>&nbsp;
            <span><b [innerHtml]="'AFB_HOVER_05' | globalTranslate"></b></span
            >&nbsp;
            <span [innerHtml]="'AFB_HOVER_06' | globalTranslate"></span>
          </li>
          } @if (!this.isFromPartnerPortal && hoveredOnAFB &&
          this.translatedLang !== 'en') {
          <li (mouseout)="hoveredOnAFB = false" class="renew-coverage">
            <span>¿<b [innerHtml]="'AFB_HOVER_01' | translate"></b></span>&nbsp;
            <span [innerHtml]="'AFB_HOVER_02' | translate"></span>&nbsp;
            <span><b [innerHtml]="'AFB_HOVER_03' | translate"></b></span>&nbsp;
            <span [innerHtml]="'AFB_HOVER_04' | translate"></span>&nbsp;
            <span [innerHtml]="'AFB_HOVER_05' | translate"></span>&nbsp;
            <span [innerHtml]="'AFB_HOVER_06' | translate"></span>&nbsp;
            <span><b [innerHtml]="'AFB_HOVER_07' | translate"></b></span>&nbsp;
          </li>
          } @if (!hasIndiv && !readTCC) {
          <li [routerLink]="['case-link']" [routerLinkActive]="['selected']">
            <a class="add-primary-color" [ngClass]="{ selected: isMyLink }">{{
              "COVERAGE_DTL_11" | globalTranslate
            }}</a>
          </li>
          } @if (!hoveredOnRenew) {
          <li
            [routerLink]="!renewalDisable ? null : ['renew-benefits']"
            [routerLinkActive]="['selected']"
            (mouseover)="hoveredOnRenew = !renewalDisable"
          >
            <a
              class="add-primary-color"
              [class.disabled]="!renewalDisable"
              [attr.tabindex]="!renewalDisable ? 0 : null"
              [attr.aria-disabled]="!renewalDisable ? 'true' : 'false'"
              [attr.role]="!renewalDisable ? 'link' : null"
            >
              {{ "RENEW_MY_COVERAGE" | globalTranslate }}</a
            >
          </li>
          } @if (hoveredOnRenew) {
          <li
            class="renew-coverage"
            (mouseout)="hoveredOnRenew = !(disableRenewal || !renewalDisable)"
          >
            <a
              tabindex="0"
              aria-describedby="renew-desc"
              aria-disabled="true"
              class="disabled-link"
            >
              {{ "RENEW_MY_COVERAGE_HOVER" | globalTranslate }}</a
            >
            <span id="renew-desc" class="visually-hidden">
              {{ "RENEW_MY_COVERAGE_HOVER" | globalTranslate }}</span
            >
          </li>
          } @if (!hoveredOnReport) {
          <li
            [routerLink]="checkReportChangeEnabled() ? null : ['report-change']"
            [routerLinkActive]="['selected']"
            (mouseover)="hoveredOnReport = checkReportChangeEnabled()"
          >
            <a
              class="add-primary-color"
              [class.disabled]="checkReportChangeEnabled()"
              [attr.tabindex]="checkReportChangeEnabled() ? 0 : null"
              [attr.aria-disabled]="
                checkReportChangeEnabled() ? 'true' : 'false'
              "
              [attr.role]="checkReportChangeEnabled() ? 'link' : null"
              >{{ "REPORT_CHANGE" | globalTranslate }}</a
            >
          </li>
          } @if (hoveredOnReport) {
          <li class="renew-coverage" (mouseout)="hoveredOnReport = disableRmc">
            {{ "REPORT_CHANGE_HOVER" | globalTranslate }}
          </li>
          } @if (appealsMasterSwitch && !this.isFromPartnerPortal &&
          showMyAppeals) {
          <li
            [routerLink]="
              medicalAppealsSwitch ? ['appeals-dashboard'] : ['my-appeals']
            "
            [ngClass]="{ selected: isMyAppealsActive }"
          >
            <a class="add-primary-color">{{
              "MY_APPEALS" | globalTranslate
            }}</a>
          </li>
          }
          <!-- <li *ngIf="!showQFR" ><a [class.disabled]="true" class="add-primary-color">{{'QFR' | globalTranslate }}</a></li>
              <li *ngIf="showQFR" [routerLink]="['pre-term']" [routerLinkActive]="['selected']"><a class="add-primary-color">{{'QFR' | globalTranslate }}</a></li> -->
          @if (!hoveredOnQFR) {
          <li
            [routerLink]="!showQFR ? null : ['pre-term']"
            [routerLinkActive]="['selected']"
            (mouseover)="hoveredOnQFR = !showQFR"
          >
            <a
              class="add-primary-color"
              [class.disabled]="!showQFR"
              [attr.tabindex]="!showQFR ? 0 : null"
              [attr.aria-disabled]="!showQFR ? 'true' : 'false'"
              [attr.role]="!showQFR ? 'link' : null"
            >
              {{ "QFR" | globalTranslate }}</a
            >
          </li>
          } @if (hoveredOnQFR) {
          <li
            class="renew-coverage"
            (mouseout)="hoveredOnQFR = !(qfrDisable || !showQFR)"
          >
            {{ "QFR_HOVER" | globalTranslate }}
          </li>
          }
        </ul>
        <hr />
      </section>
      <section
        id="step8"
        #step8
        joyrideStep="Step8"
        stepPosition="right"
        text="{{ 'TUTORIAL_3' | globalTranslate }}"
        class="side-section"
      >
        <div class="sub-title">
          <span>{{ "HOUSE_HOLD_DOCUMENTS" | globalTranslate }}</span>
        </div>
        <ul>
          <li [routerLink]="['my-documents']" [routerLinkActive]="['selected']">
            <a class="add-primary-color">{{
              "MY_DOCUMENTS" | globalTranslate
            }}</a>
          </li>
          <li [routerLink]="['letters']" [routerLinkActive]="['selected']">
            <a class="add-primary-color">{{
              "MY_LETTERS" | globalTranslate
            }}</a>
          </li>
          @if (!readTCC) {
          <li
            [routerLink]="['my-submissions']"
            [routerLinkActive]="['selected']"
          >
            <a class="add-primary-color">{{
              "MY_SUBMISSONS" | globalTranslate
            }}</a>
          </li>
          } @if (readTCC) {
          <li>
            <a
              class="add-primary-color"
              [class.disabled]="readTCC"
              [attr.tabindex]="readTCC ? 0 : null"
              [attr.aria-disabled]="readTCC ? 'true' : 'false'"
              [attr.role]="readTCC ? 'link' : null"
              >{{ "MY_SUBMISSONS" | globalTranslate }}</a
            >
          </li>
          } @if (!readTCC) {
          <li (click)="dashboardTutorial()">
            <a
              tabindex="0"
              [attr.aria-label]="'DASHBOARD_TUTORIAL' | globalTranslate"
              class="add-primary-color"
              >{{ "DASHBOARD_TUTORIAL" | globalTranslate }}</a
            >
          </li>
          } @if (readTCC) {
          <li>
            <a
              class="add-primary-color"
              [class.disabled]="readTCC"
              [attr.tabindex]="readTCC ? 0 : null"
              [attr.aria-disabled]="readTCC ? 'true' : 'false'"
              [attr.role]="readTCC ? 'link' : null"
              >{{ "DASHBOARD_TUTORIAL" | globalTranslate }}</a
            >
          </li>
          }
        </ul>
        <hr />
      </section>
      <section>
        <div class="sub-title">
          <span>{{ "MANAGE_MY" | globalTranslate }}</span>
        </div>
        <ul>
          @if (!readTCC && !viewTCC) {
          <li
            [routerLink]="['/user-profile/manage-account']"
            [routerLinkActive]="['selected']"
          >
            <a class="add-primary-color">{{ "MANAGE_MY" | globalTranslate }}</a>
          </li>
          } @if (readTCC || viewTCC) {
          <li>
            <a
              class="add-primary-color"
              [class.disabled]="readTCC || viewTCC"
              [attr.tabindex]="readTCC || viewTCC ? 0 : null"
              [attr.aria-disabled]="readTCC || viewTCC ? 'true' : 'false'"
              [attr.role]="readTCC || viewTCC ? 'link' : null"
              >{{ "MANAGE_MY" | globalTranslate }}</a
            >
          </li>
          } @if (!hoveredOnCommunicate) {
          <li
            [routerLink]="
              !hasIndiv || readTCC
                ? null
                : ['/user-profile/communication-preferences']
            "
            (mouseover)="
              hoveredOnCommunicate = !hasIndiv || readTCC || !isLoggedUserHoh
            "
            [routerLinkActive]="['selected']"
          >
            <a
              class="add-primary-color"
              [class.disabled]="!hasIndiv || readTCC || !isLoggedUserHoh"
              [attr.tabindex]="!hasIndiv || readTCC ? 0 : null"
              [attr.aria-disabled]="!hasIndiv || readTCC ? 'true' : 'false'"
              [attr.role]="!hasIndiv || readTCC ? 'link' : null"
              >{{ "COMMUNICATION_TITLE" | globalTranslate }}</a
            >
          </li>
          } @if (hoveredOnCommunicate && !readTCC && isLoggedUserHoh) {
          <li
            class="renew-coverage"
            (mouseout)="
              hoveredOnCommunicate ? (hoveredOnCommunicate = hasIndiv) : ''
            "
            [routerLinkActive]="['selected']"
          >
            {{ "COMMUNICATION_TITLE" | globalTranslate }}
          </li>
          } @if (hoveredOnCommunicate && (readTCC || !isLoggedUserHoh)) {
          <li
            class="renew-coverage"
            (mouseout)="
              hoveredOnCommunicate
                ? (hoveredOnCommunicate = !(
                    hasIndiv ||
                    readTCC ||
                    !isLoggedUserHoh
                  ))
                : ''
            "
            [routerLinkActive]="['selected']"
          >
            {{ "COMMUNICATION_TITLE" | globalTranslate }}
          </li>
          } @if (!this.isFromPartnerPortal && showIdVerifyLink &&
          enableRIDPFlow) {
          <li class="d-flex" (click)="openIdverifyModal()">
            <a
              class="add-primary-color me-2"
              tabindex="0"
              [attr.aria-label]="'RIDP_TITLE' | globalTranslate"
              >{{ "RIDP_TITLE" | globalTranslate }}</a
            >
            <img
              class="warning_icon"
              src="../../../assets/images/Icons/icons-warning-outline-red.svg"
              alt="warning"
              aria-hidden="true"
              role="presentation"
            />
          </li>
          }
        </ul>
        <hr />
      </section>
    </div>
  </div>
  }
</div>
<div class="container">
  <br />
  @if (isManageAccountActive) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "MANAGE_MY" | globalTranslate }}</h1>
    </div>
  </div>
  }
  <nh-alert type="warning" [isOpen]="successMessage?.updatedEmail">
    <div class="row" tabindex="0">
      <div class="col-auto icon">
        <img
          src="../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ "UPDATED_EMAIL" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
  <nh-alert type="success" [isOpen]="successMessage?.updatedPassword">
    <div class="row" tabindex="0">
      <div class="col-auto icon">
        <img
          src="../../../../assets/images/Icons/⚛️ icons-checkmark-outline.svg"
          alt="success"
        />
      </div>
      <div class="col message">
        <span>{{ "PWD_CHANGE" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
  <nh-alert type="success" [isOpen]="successMessage?.updatedSecurityQuestions">
    <div class="row" tabindex="0">
      <div class="col-auto icon">
        <img
          src="../../../../assets/images/Icons/⚛️ icons-checkmark-outline.svg"
          alt="success"
        />
      </div>
      <div class="col message">
        <span>{{ "SECURITY_QUES_CHANGE" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
  @if (changePasswordLinkActive) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "CHANGE_PASSWORD" | globalTranslate }}</h1>
    </div>
  </div>
  } @if (iscommunicationPrefActive) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "COMMUNICATION_TITLE" | globalTranslate }}</h1>
    </div>
  </div>
  }
  <div>
    <nh-alert
      type="danger"
      [isOpen]="communicationPreferencesSvc.communicationAlertShow"
    >
      <div class="row" tabindex="0">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>
            {{ "COMMUNICATION_PREFERENCE_ALERT" | globalTranslate }}
          </span>
        </div>
      </div>
    </nh-alert>
  </div>
  @if (healthPlanDetailsTitle) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "HEALTH_PLAN_DETAILS" | globalTranslate }}</h1>
    </div>
    <div class="ps-1 pb-1 hover-red">
      <div class="btn btn-link hover-red" tabindex="0" (click)="onPrevious()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.875"
          height="15.75"
          viewBox="0 0 16.875 15.75"
        >
          <g
            id="_icons_arrow-back-outline"
            data-name="⚛️ icons/arrow-back-outline"
            transform="translate(0)"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)"
              fill="#174a7c"
            />
          </g>
        </svg>
        <span class="ps-2">{{ "BACK_TO_DASHBOARD" | globalTranslate }}</span>
      </div>
    </div>
  </div>
  } @if (budgetDetailsTitle) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "BUDGET_DETAILS" | globalTranslate }}</h1>
    </div>
  </div>
  } @if (appealContinuanceTitle || appealWithdrawalTitle ||
  appealFactSubmissionTitle || appealPetitionSubmissionTitle) {
  <div class="row mb-3">
    @if (appealContinuanceTitle) {
    <div class="col-11">
      <h1 class="page-title">{{ "CONTINUANCE_REQUEST" | globalTranslate }}</h1>
      <br />
    </div>
    } @if (appealWithdrawalTitle) {
    <div class="col-11">
      <h1 class="page-title">{{ "WITHDRAWAL_REQUEST" | globalTranslate }}</h1>
      <br />
    </div>
    } @if (appealFactSubmissionTitle) {
    <div class="col-11">
      <h1 class="page-title">
        {{ "APPEAL_FACT_SUBMISSION" | globalTranslate }}
      </h1>
      <br />
    </div>
    } @if (appealPetitionSubmissionTitle) {
    <div class="col-11">
      <h1 class="page-title">{{ "APL_PTIN_FORM_TITLE" | globalTranslate }}</h1>
      <br />
    </div>
    }
    <div class="ps-1 pb-1 hover-red" tabindex="0">
      <div class="btn btn-link hover-red" (click)="toAppealsDashboard()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.875"
          height="15.75"
          viewBox="0 0 16.875 15.75"
        >
          <g
            id="_icons_arrow-back-outline"
            data-name="⚛️ icons/arrow-back-outline"
            transform="translate(0)"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)"
              fill="#174a7c"
            />
          </g>
        </svg>
        <span class="ps-2">{{
          "BACK_TO_APPEALS_DASHBOARD" | globalTranslate
        }}</span>
      </div>
    </div>
  </div>
  } @if (myDocumentsTitle) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "MY_DOCUMENTS_1" | globalTranslate }}</h1>
    </div>
    @if (showLeftPanel && !this.isFromPartnerPortal) {
    <div class="ps-1 pb-1 hover-red">
      <div tabindex="0" class="btn btn-link hover-red" (click)="onPrevious()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.875"
          height="15.75"
          viewBox="0 0 16.875 15.75"
        >
          <g
            id="_icons_arrow-back-outline"
            data-name="⚛️ icons/arrow-back-outline"
            transform="translate(0)"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)"
              fill="#174a7c"
            />
          </g>
        </svg>
        <span class="ps-2">{{
          "BACK_TO_PREVIOUS_PAGE" | globalTranslate
        }}</span>
      </div>
    </div>
    }
  </div>
  } @if (updateEmailLinkActive) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "CHANGE_EMAIL" | globalTranslate }}</h1>
    </div>
  </div>
  } @if (mySubmissions) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">
        {{ "MY_SUBMISSIONS_HEADER" | globalTranslate }}
      </h1>
    </div>
  </div>
  } @if (myLetters) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "MY_LETTERS_HEADER" | globalTranslate }}</h1>
    </div>
  </div>
  } @if (autoRenewal) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "COVERAGE_OVERVIEW" | globalTranslate }}</h1>
    </div>
    @if (showLeftPanel) {
    <div class="ps-1 pb-1 hover-red">
      <div class="btn btn-link hover-red" tabindex="0" (click)="onPrevious()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.875"
          height="15.75"
          viewBox="0 0 16.875 15.75"
        >
          <g
            id="_icons_arrow-back-outline"
            data-name="⚛️ icons/arrow-back-outline"
            transform="translate(0)"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)"
              fill="#174a7c"
            />
          </g>
        </svg>
        <span class="ps-2">{{ "BACK_TO_DASHBOARD" | globalTranslate }}</span>
      </div>
    </div>
    }
  </div>
  } @if (updateSecurityQuestionsLinkActive) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "CHANGE_SECURITY_QUES" | globalTranslate }}</h1>
    </div>
  </div>
  } @if (isLinkYourCaseActive) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "LINK_CASE_TITLE" | globalTranslate }}</h1>
    </div>
  </div>
  } @if (isLinkYourCaseActive) {
  <nh-alert type="danger" [isOpen]="linkCaseService.isError">
    <div class="row" tabindex="0">
      <div class="col-auto icon">
        <img
          src="../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      @if (linkCaseService.errorMessage == 'ERROR_PERSON_ID_18') {
      <div class="col message">
        <span>{{ "ERROR_PERSON_ID_18" | globalTranslate }}</span>
      </div>
      } @if (linkCaseService.errorMessage == 'INDIV_NOT_FOUND') {
      <div class="col message">
        <span>{{ "INDIV_NOT_FOUND" | globalTranslate }}</span>
      </div>
      } @if (linkCaseService.errorMessage == 'ERROR_EXISTING_INDIVIDUAL') {
      <div class="col message">
        <span>{{ "ERROR_EXISTING_INDIVIDUAL" | globalTranslate }}</span>
      </div>
      } @if (linkCaseService.errorMessage == 'APPLICATION_PENDING') {
      <div class="col message">
        <span>{{ "APPLICATION_PENDING" | globalTranslate }}</span>
      </div>
      } @if (linkCaseService.errorMessage == 'NO_LINKING_DCS_FOSTER') {
      <div class="col message">
        <span>{{ "NO_LINKING_DCS_FOSTER" | globalTranslate }}</span>
      </div>
      } @if (linkCaseService.errorMessage == 'GENERIC_LINKCASE_ERROR_MESSAGE') {
      <div class="col message">
        <span>{{ "GENERIC_LINKCASE_ERROR_MESSAGE" | globalTranslate }}</span>
      </div>
      }
    </div>
  </nh-alert>
  } @if (this.isFromPartnerPortal) {
  <button (click)="backToPartnerPortal()" class="btn btn-secondary btn-lg">
    Back to TennCare Access
  </button>
  } @if (isBenefitDashboardActive) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "DASHBOARD_TITLE" | globalTranslate }}</h1>
    </div>
  </div>
  } @if (appealDashboardTitle) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">
        {{
          (medicalAppealsSwitch
            ? "MY_ELIGIBILITY_APPEALS_TITLE"
            : "APPEAL_DASHBOARD"
          ) | globalTranslate
        }}
      </h1>
    </div>
    <div class="ps-3 pb-1 hover-red">
      @if (!medicalAppealsSwitch) {
      <div class="btn btn-link hover-red" tabindex="0" (click)="onPrevious()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.875"
          height="15.75"
          viewBox="0 0 16.875 15.75"
        >
          <g
            id="_icons_arrow-back-outline"
            data-name="⚛️ icons/arrow-back-outline"
            transform="translate(0)"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)"
              fill="#174a7c"
            />
          </g>
        </svg>
        <span class="ps-2">{{ "BACK_TO_DASHBOARD" | globalTranslate }}</span>
      </div>
      } @if (medicalAppealsSwitch) {
      <div
        class="btn btn-link hover-red"
        tabindex="0"
        (click)="goToAppealsDashboard()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.875"
          height="15.75"
          viewBox="0 0 16.875 15.75"
        >
          <g
            id="_icons_arrow-back-outline"
            data-name="⚛️ icons/arrow-back-outline"
            transform="translate(0)"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)"
              fill="#174a7c"
            />
          </g>
        </svg>
        <span class="ps-2">{{ "BACK_TO_MYAPPEALS" | globalTranslate }}</span>
      </div>
      }
    </div>
  </div>
  } @if (isCoverageDetailsActive) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">
        {{ "COVERAGE_DETAILS_TITLE_UPDATED" | globalTranslate }}
      </h1>
    </div>
  </div>
  } @if (isCoverageDetailsActive) {
  <div class="ps-1 pb-1 hover-red">
    <div tabindex="0" class="btn btn-link hover-red" (click)="onPrevious()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.875"
        height="15.75"
        viewBox="0 0 16.875 15.75"
      >
        <g
          id="_icons_arrow-back-outline"
          data-name="⚛️ icons/arrow-back-outline"
          transform="translate(0)"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
            transform="translate(0)"
            fill="#174a7c"
          />
        </g>
      </svg>
      <span class="ps-2">{{ "BACK_TO_PREVIOUS_PAGE" | globalTranslate }}</span>
    </div>
  </div>
  } @if (submissionStatus && submissionStatusSwitch) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title app_title" tabindex="0">
        {{ "APPLICATION_STATUS" | globalTranslate }}
      </h1>
    </div>
    <div class="ps-3 pb-1 hover-red">
      <div class="btn btn-link hover-red" tabindex="0" (click)="onPrevious()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.875"
          height="15.75"
          viewBox="0 0 16.875 15.75"
        >
          <g
            id="_icons_arrow-back-outline"
            data-name="⚛️ icons/arrow-back-outline"
            transform="translate(0)"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)"
              fill="#174a7c"
            />
          </g>
        </svg>
        <span class="ps-2">{{ "BACK_TO_DASHBOARD" | globalTranslate }}</span>
      </div>
    </div>
  </div>
  } @if (myAppealsTitle) {
  <div class="row mb-3">
    <div class="col-11">
      <h1 class="page-title">{{ "MY_APPEALS" | globalTranslate }}</h1>
    </div>
    <div class="ps-3 pb-1 hover-red">
      <div class="btn btn-link hover-red" tabindex="0" (click)="onPrevious()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.875"
          height="15.75"
          viewBox="0 0 16.875 15.75"
        >
          <g
            id="_icons_arrow-back-outline"
            data-name="⚛️ icons/arrow-back-outline"
            transform="translate(0)"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)"
              fill="#174a7c"
            />
          </g>
        </svg>
        <span class="ps-2">{{ "BACK_TO_DASHBOARD" | globalTranslate }}</span>
      </div>
    </div>
  </div>
  }
  <div class="row my-1">
    @if (showLeftPanel) {
    <div class="col-3 col-md-4 pr-1 mt-md-6 col-lg-3">
      @if (submissionStatusSwitch) {
      <div class="card d-none d-lg-block d-md-block shadow-sm mb-3">
        <div
          class="card-user mobile-responsive link-style"
          id="step1"
          #step1
          joyrideStep="Step1"
          stepPosition="bottom"
          text="{{ 'TUTORIAL_1' | globalTranslate }}"
        >
          <section class="side-section-header">
            <div class="row">
              <div class="col-2 profile-pic" aria-hidden="true">
                <img src="../../../assets/images/profile_pic.svg" alt="" />
              </div>
              <div class="col-10 profile-details">
                <div class="profile-name">
                  <span>
                    {{ userDetails?.firstName }}
                    {{ userDetails?.middleName }}
                    {{ userDetails?.lastName }}
                  </span>
                </div>
                <div class="profile-email">
                  {{
                    userDetails?.emailId
                      ? userDetails?.emailId
                      : userDetails?.email
                  }}
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="sub-title">
              <span>{{ "MANAGE_YOUR_APPLICATIONS" | globalTranslate }}</span>
            </div>
            <div class="appstatus_container mt-3">
              <div class="sub_content" [routerLink]="['application-status']">
                <span style="align-content: space-evenly"
                  ><img
                    class="app_status_icon"
                    alt=""
                    src="../../../assets/images/Icons/Welcome_SearchSubmissions.svg"
                /></span>
                <a
                  class="add-primary-color app_status"
                  [ngStyle]="
                    currentGlobalLang === 'tl'
                      ? { 'font-size': '15px' }
                      : translatedLang === 'sp' ||
                        (currentGlobalLang !== null &&
                          currentGlobalLang !== 'tl')
                      ? { fontSize: '17px' }
                      : { 'font-size': '16px' }
                  "
                  >{{ "APPLICATION_STATUS" | globalTranslate }}</a
                >
              </div>
            </div>
          </section>
        </div>
      </div>
      }
      <div class="card d-none d-lg-block d-md-block shadow-sm">
        <div class="card-user mobile-responsive link-style">
          @if (!submissionStatusSwitch) {
          <div
            class="card-user mobile-responsive link-style"
            id="step1"
            #step1
            joyrideStep="Step1"
            stepPosition="bottom"
            text="{{ 'TUTORIAL_1_MOBILE' | globalTranslate }}"
          >
            <section class="side-section-header">
              <div class="row">
                <div class="col-2 profile-pic" aria-hidden="true">
                  <img
                    src="../../../assets/images/profile_pic.svg"
                    alt="profile pic"
                  />
                </div>
                <div class="col-10 profile-details">
                  <div class="profile-name">
                    <span>
                      {{ userDetails?.firstName }}
                      {{ userDetails?.middleName }}
                      {{ userDetails?.lastName }}
                    </span>
                  </div>
                  <div class="profile-email">
                    {{
                      userDetails?.emailId
                        ? userDetails?.emailId
                        : userDetails?.email
                    }}
                  </div>
                </div>
              </div>
            </section>
          </div>
          }
          <section
            id="step2"
            #step2
            joyrideStep="Step2"
            stepPosition="right"
            text="{{ 'TUTORIAL_2' | globalTranslate }}"
            class="side-section"
          >
            <div class="sub-title" [routerLink]="['benefit-dashboard']">
              <span>{{ "MY_COVERAGE" | globalTranslate }}</span>
            </div>
            <ul>
              <li
                [routerLink]="['benefit-dashboard']"
                [ngClass]="{ selected: isCoverageDetailsActive }"
                [routerLinkActive]="['selected']"
              >
                <a class="add-primary-color">{{
                  "COVERAGE_DASHBOARD" | globalTranslate
                }}</a>
              </li>
              @if (!hoveredOnHealthPlan && !this.isFromPartnerPortal &&
              mcoMasterSwitch && showHealthPlanDetails) {
              <li
                [routerLink]="['healthplan-details']"
                [routerLinkActive]="['selected']"
                (mouseover)="hoveredOnHealthPlan = !showHealthPlanDetails"
              >
                <a class="add-primary-color">
                  {{ "HEALTH_PLAN_DETAILS" | globalTranslate }}</a
                >
              </li>
              }
              <!-- <li *ngIf="hoveredOnHealthPlan && !this.isFromPartnerPortal && mcoMasterSwitch" class="renew-coverage" (mouseout)="hoveredOnHealthPlan = showHealthPlanDetails ">{{'REPORT_CHANGE_HOVER' | globalTranslate }}</li> -->
              @if (!this.isFromPartnerPortal && !hoveredOnAFB) {
              <li
                (mouseover)="hoveredOnAFB = isLinkDisable"
                (click)="isLinkDisable ? $event.preventDefault() : applyNow()"
              >
                <a
                  tabindex="0"
                  [class.disabled]="isLinkDisable"
                  class="add-primary-color"
                  [attr.aria-label]="
                    ('WELCOME_APPLY_COVERAGE_HEADER' | globalTranslate) +
                    (isLinkDisable ? ' ' + 'unavailable' : '')
                  "
                  >{{ "WELCOME_APPLY_COVERAGE_HEADER" | globalTranslate }}</a
                >
              </li>
              } @if (!this.isFromPartnerPortal && hoveredOnAFB &&
              this.translatedLang === 'en') {
              <li (mouseout)="hoveredOnAFB = false" class="renew-coverage">
                <span
                  ><b [innerHtml]="'AFB_HOVER_01' | globalTranslate"></b></span
                >&nbsp;
                <span [innerHtml]="'AFB_HOVER_02' | globalTranslate"></span
                >&nbsp;
                <span
                  ><b [innerHtml]="'AFB_HOVER_03' | globalTranslate"></b></span
                >&nbsp;
                <span [innerHtml]="'AFB_HOVER_04' | globalTranslate"></span
                >&nbsp;
                <span
                  ><b [innerHtml]="'AFB_HOVER_05' | globalTranslate"></b></span
                >&nbsp;
                <span [innerHtml]="'AFB_HOVER_06' | globalTranslate"></span>
              </li>
              } @if (!this.isFromPartnerPortal && hoveredOnAFB &&
              this.translatedLang !== 'en') {
              <li (mouseout)="hoveredOnAFB = false" class="renew-coverage">
                <span>¿<b [innerHtml]="'AFB_HOVER_01' | translate"></b></span
                >&nbsp;
                <span [innerHtml]="'AFB_HOVER_02' | translate"></span>&nbsp;
                <span><b [innerHtml]="'AFB_HOVER_03' | translate"></b></span
                >&nbsp;
                <span [innerHtml]="'AFB_HOVER_04' | translate"></span>&nbsp;
                <span [innerHtml]="'AFB_HOVER_05' | translate"></span>&nbsp;
                <span [innerHtml]="'AFB_HOVER_06' | translate"></span>&nbsp;
                <span><b [innerHtml]="'AFB_HOVER_07' | translate"></b></span
                >&nbsp;
              </li>
              } @if (!hasIndiv && !readTCC) {
              <li
                [routerLink]="['case-link']"
                [routerLinkActive]="['selected']"
              >
                <a
                  class="add-primary-color"
                  [ngClass]="{ selected: isMyLink }"
                  >{{ "COVERAGE_DTL_11" | globalTranslate }}</a
                >
              </li>
              } @if (!hoveredOnRenew) {
              <li
                [routerLink]="!renewalDisable ? null : ['renew-benefits']"
                [routerLinkActive]="['selected']"
                (mouseover)="hoveredOnRenew = !renewalDisable"
              >
                <a
                  class="add-primary-color"
                  [class.disabled]="!renewalDisable"
                  [attr.tabindex]="!renewalDisable ? 0 : null"
                  [attr.aria-disabled]="!renewalDisable ? 'true' : 'false'"
                  [attr.role]="!renewalDisable ? 'link' : null"
                >
                  {{ "RENEW_MY_COVERAGE" | globalTranslate }}</a
                >
              </li>
              } @if (hoveredOnRenew) {
              <li
                class="renew-coverage"
                (mouseout)="
                  hoveredOnRenew = !(disableRenewal || !renewalDisable)
                "
              >
                {{ "RENEW_MY_COVERAGE_HOVER" | globalTranslate }}
              </li>
              } @if (!hoveredOnReport) {
              <li
                [routerLink]="
                  checkReportChangeEnabled() ? null : ['report-change']
                "
                [routerLinkActive]="['selected']"
                (mouseover)="hoveredOnReport = checkReportChangeEnabled()"
              >
                <a
                  class="add-primary-color"
                  [class.disabled]="checkReportChangeEnabled()"
                  [attr.tabindex]="checkReportChangeEnabled() ? 0 : null"
                  [attr.aria-disabled]="
                    checkReportChangeEnabled() ? 'true' : 'false'
                  "
                  [attr.role]="checkReportChangeEnabled() ? 'link' : null"
                  >{{ "REPORT_CHANGE" | globalTranslate }}</a
                >
              </li>
              } @if (hoveredOnReport) {
              <li
                class="renew-coverage"
                (mouseout)="hoveredOnReport = disableRmc"
              >
                {{ "REPORT_CHANGE_HOVER" | globalTranslate }}
              </li>
              } @if (appealsMasterSwitch && !this.isFromPartnerPortal &&
              showMyAppeals) {
              <li
                [routerLink]="
                  medicalAppealsSwitch ? ['appeals-dashboard'] : ['my-appeals']
                "
                [ngClass]="{ selected: isMyAppealsActive }"
                (click)="continuance()"
              >
                <a class="add-primary-color">{{
                  "MY_APPEALS" | globalTranslate
                }}</a>
              </li>
              }
              <!-- <li *ngIf="!showQFR"><a [class.disabled]="true" class="add-primary-color">{{'QFR' | globalTranslate }}</a></li>
                                                        <li *ngIf="showQFR" [routerLink]="['pre-term']" [routerLinkActive]="['selected']"><a class="add-primary-color">{{'QFR' | globalTranslate }}</a></li> -->
              @if (!hoveredOnQFR) {
              <li
                [routerLink]="!showQFR ? null : ['pre-term']"
                [routerLinkActive]="['selected']"
                (mouseover)="hoveredOnQFR = !showQFR"
              >
                <a
                  class="add-primary-color"
                  [class.disabled]="!showQFR"
                  [attr.tabindex]="!showQFR ? 0 : null"
                  [attr.aria-disabled]="!showQFR ? 'true' : 'false'"
                  [attr.role]="!showQFR ? 'link' : null"
                >
                  {{ "QFR" | globalTranslate }}</a
                >
              </li>
              } @if (hoveredOnQFR) {
              <li
                class="renew-coverage"
                (mouseout)="hoveredOnQFR = !(qfrDisable || !showQFR)"
              >
                {{ "QFR_HOVER" | globalTranslate }}
              </li>
              }
            </ul>
            <hr />
          </section>
          <section
            id="step3"
            #step3
            joyrideStep="Step3"
            stepPosition="right"
            text="{{ 'TUTORIAL_3' | globalTranslate }}"
            class="side-section"
          >
            <div class="sub-title">
              <span>{{ "HOUSE_HOLD_DOCUMENTS" | globalTranslate }}</span>
            </div>
            <ul>
              <li
                [routerLink]="['my-documents']"
                [routerLinkActive]="['selected']"
              >
                <a class="add-primary-color">{{
                  "MY_DOCUMENTS" | globalTranslate
                }}</a>
              </li>
              <li [routerLink]="['letters']" [routerLinkActive]="['selected']">
                <a class="add-primary-color">{{
                  "MY_LETTERS" | globalTranslate
                }}</a>
              </li>
              @if (!readTCC) {
              <li
                [routerLink]="readTCC ? null : ['my-submissions']"
                [routerLinkActive]="['selected']"
              >
                <a class="add-primary-color">{{
                  "MY_SUBMISSONS" | globalTranslate
                }}</a>
              </li>
              } @if (readTCC) {
              <li>
                <a
                  class="add-primary-color"
                  [class.disabled]="readTCC"
                  [attr.tabindex]="readTCC ? 0 : null"
                  [attr.aria-disabled]="readTCC ? 'true' : 'false'"
                  [attr.role]="readTCC ? 'link' : null"
                  >{{ "MY_SUBMISSONS" | globalTranslate }}</a
                >
              </li>
              } @if (!readTCC) {
              <li (click)="dashboardTutorial()">
                <a
                  class="add-primary-color"
                  tabindex="0"
                  [attr.aria-label]="'DASHBOARD_TUTORIAL' | globalTranslate"
                  id="tutorial"
                  >{{ "DASHBOARD_TUTORIAL" | globalTranslate }}</a
                >
              </li>
              } @if (readTCC) {
              <li>
                <a
                  class="add-primary-color"
                  [class.disabled]="readTCC"
                  [attr.tabindex]="readTCC ? 0 : null"
                  [attr.aria-disabled]="readTCC ? 'true' : 'false'"
                  [attr.role]="readTCC ? 'link' : null"
                  id="tutorial"
                  >{{ "DASHBOARD_TUTORIAL" | globalTranslate }}</a
                >
              </li>
              }
            </ul>
            <hr />
          </section>
          <section>
            <div class="sub-title">
              <span>{{ "MANAGE_MY" | globalTranslate }}</span>
            </div>
            <ul>
              @if (!readTCC && !viewTCC) {
              <li
                [routerLink]="['/user-profile/manage-account']"
                [routerLinkActive]="['selected']"
              >
                <a class="add-primary-color">{{
                  "MANAGE_MY" | globalTranslate
                }}</a>
              </li>
              } @if (readTCC || viewTCC) {
              <li>
                <a
                  class="add-primary-color"
                  [class.disabled]="readTCC || viewTCC"
                  [attr.tabindex]="readTCC || viewTCC ? 0 : null"
                  [attr.aria-disabled]="readTCC || viewTCC ? 'true' : 'false'"
                  [attr.role]="readTCC || viewTCC ? 'link' : null"
                  >{{ "MANAGE_MY" | globalTranslate }}</a
                >
              </li>
              } @if (!hoveredOnCommunicate) {
              <li
                [routerLink]="
                  !hasIndiv || readTCC
                    ? null
                    : ['/user-profile/communication-preferences']
                "
                (mouseover)="
                  hoveredOnCommunicate =
                    !hasIndiv || readTCC || !isLoggedUserHoh
                "
                [routerLinkActive]="['selected']"
              >
                <a
                  class="add-primary-color"
                  [class.disabled]="!hasIndiv || readTCC || !isLoggedUserHoh"
                  [attr.tabindex]="!hasIndiv || readTCC ? 0 : null"
                  [attr.aria-disabled]="!hasIndiv || readTCC ? 'true' : 'false'"
                  [attr.role]="!hasIndiv || readTCC ? 'link' : null"
                  >{{ "COMMUNICATION_TITLE" | globalTranslate }}</a
                >
              </li>
              } @if (hoveredOnCommunicate && !readTCC && isLoggedUserHoh) {
              <li
                class="renew-coverage"
                (mouseout)="
                  hoveredOnCommunicate ? (hoveredOnCommunicate = hasIndiv) : ''
                "
                [routerLinkActive]="['selected']"
              >
                {{ "COMMUNICATION_TITLE" | globalTranslate }}
              </li>
              } @if (hoveredOnCommunicate && (readTCC || !isLoggedUserHoh)) {
              <li
                class="renew-coverage"
                (mouseout)="
                  hoveredOnCommunicate
                    ? (hoveredOnCommunicate = !(
                        hasIndiv ||
                        readTCC ||
                        !isLoggedUserHoh
                      ))
                    : ''
                "
                [routerLinkActive]="['selected']"
              >
                {{ "COMMUNICATION_TITLE" | globalTranslate }}
              </li>
              } @if (!this.isFromPartnerPortal && showIdVerifyLink &&
              enableRIDPFlow) {
              <li class="d-flex" (click)="openIdverifyModal()">
                <a
                  class="add-primary-color me-2"
                  tabindex="0"
                  [attr.aria-label]="'RIDP_TITLE' | globalTranslate"
                  >{{ "RIDP_TITLE" | globalTranslate }}</a
                >
                <img
                  class="warning_icon"
                  src="../../../assets/images/Icons/icons-warning-outline-red.svg"
                  alt="warning"
                  aria-hidden="true"
                  role="presentation"
                />
              </li>
              }
            </ul>
            <hr />
          </section>
        </div>
      </div>
    </div>
    }
    <div
      [ngClass]="{
        'col-md-12': !showLeftPanel,
        'col-lg-9 col-md-8 col-sm-12 pl-1 pr-1': showLeftPanel
      }"
    >
      <router-outlet></router-outlet>
    </div>
    @if (updateEmailLinkActive) {
    <div>
      <div class="row mt-3 pt-4">
        <div class="col-auto me-3">
          <button
            id="continue"
            [disabled]="changeEmailService?.updateEmailFrom?.invalid"
            class="btn btn-secondary"
            (click)="updateEmail1()"
          >
            {{ "SAVE" | globalTranslate }}
          </button>
        </div>
      </div>
      <br />
      <br />
    </div>
    } @if (changePasswordLinkActive) {
    <div>
      <div class="row mt-3 pt-4">
        <div class="col-auto me-3">
          <button
            id="continue"
            [disabled]="!isPasswordFormValid()"
            class="btn btn-secondary"
            (click)="updatePassword()"
          >
            {{ "SAVE" | globalTranslate }}
          </button>
        </div>
      </div>
      <br />
      <br />
    </div>
    } @if (updateSecurityQuestionsLinkActive) {
    <div>
      <div class="row mt-3 pt-4">
        <div class="col-auto me-3">
          <button
            id="continue"
            [disabled]="updateSecurityQuestions?.invalid"
            class="btn btn-secondary"
            (click)="saveSecurityQuestion()"
          >
            {{ "UPDATE" | globalTranslate }}
          </button>
        </div>
      </div>
      <br />
      <br />
    </div>
    } @if (isLinkYourCaseActive) {
    <div class="col-md-12">
      <div class="row g-0 mt-3 py-4 justify-content-md-start text-md-left">
        <div
          class="col-12 col-sm-auto mb-2 mb-sm-0 me-sm-3 d-flex justify-content-center justify-content-md-start"
        >
          <button
            id="continue"
            class="btn btn-block btn-secondary btn-width"
            (click)="linkCaseService.saveCaseLink()"
            [disabled]="linkCaseService.caseLinkfrom.invalid"
          >
            {{ "NEXT" | globalTranslate }}
          </button>
        </div>
        <div
          class="col-12 col-sm-auto d-flex justify-content-center justify-content-md-start"
        >
          <button
            id="btn-cancel"
            class="btn btn-block btn-outline-secondary"
            [ngClass]="{ 'width-translate': increaseWidth() }"
            (click)="linkCaseService.onCancel()"
          >
            {{ "CANCEL" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
    } @if (iscommunicationPrefActive) {
    <div class="col-md-12">
      <div class="row g-0 mt-3 text-center py-4">
        <div class="col-auto me-3">
          <button
            id="continue"
            class="btn btn-block btn-secondary btn-width"
            (click)="communicationPreferencesSvc.setUserAction('save')"
            [disabled]="
              !communicationPreferencesSvc.communicationPreferFormState
            "
          >
            {{ "UPDATE" | globalTranslate }}
          </button>
        </div>
        <div class="col-auto me-3">
          <button
            id="btn-cancel"
            class="btn btn-block btn-outline-secondary"
            (click)="communicationPreferencesSvc.setUserAction('cancel')"
            [disabled]="
              !communicationPreferencesSvc.communicationPreferFormState
            "
            [ngClass]="{ 'width-translate': increaseWidth() }"
          >
            {{ "CANCEL" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
    } @if (isManageAccountActive) {
    <div class="col-md-12">
      <div class="row g-0 mt-3 text-center py-4">
        <div class="col-auto me-3">
          <button
            id="continue"
            class="btn btn-block btn-secondary btn-width"
            (click)="createAccount.setmanageAccountAction('next')"
            [disabled]="!createAccount.manageAccountFormUpdateState"
          >
            {{ "NEXT_BUTTON" | globalTranslate }}
          </button>
        </div>
        <div class="col-auto me-3">
          <button
            id="btn-cancel"
            class="btn btn-block btn-outline-secondary"
            [ngClass]="{ 'width-translate': increaseWidth() }"
            (click)="createAccount.setmanageAccountAction('cancel')"
            [disabled]="!createAccount.manageAccountFormUpdateState"
          >
            {{ "CANCEL" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
    }
  </div>
</div>